import { Modal as BSModal } from 'react-bootstrap';

export default function Modal({
    show,
    onHide,
    title,
    size,
    centered = true,
    scrollable = false,
    children,
    footer,
}) {
    return (
        <BSModal
            show={show}
            onHide={onHide}
            size={size}
            centered={centered}
            scrollable={scrollable}
        >
            {title && (
                <BSModal.Header closeButton>
                    <BSModal.Title>{title}</BSModal.Title>
                </BSModal.Header>
            )}
            <BSModal.Body>{children}</BSModal.Body>
            {footer && <BSModal.Footer>{footer}</BSModal.Footer>}
        </BSModal>
    );
}
